<template>
  <section id="metodo" class="method-section" aria-labelledby="method-title">
    <img
      class="section-bg"
      src="/images/athlete-starting-line-stadium.webp"
      alt=""
      aria-hidden="true"
      loading="lazy"
    />
    <div class="method-inner">
      <header class="method-header">
        <h2 id="method-title" class="method-title">Il nostro metodo</h2>
        <p class="method-subtitle">
Ogni intervento segue un metodo esplicito. Applichiamo criteri operativi derivati dalle evidenze scientifiche e li adattiamo al contesto reale della società sportiva. Stiamo definendo un protocollo con principi, parametri, progressioni e monitoraggio: sarà la base della piattaforma digitale, per garantire coerenza tra consulenza e tecnologia.        </p>

      </header>
      <div class="method-grid">
        <article class="method-card">
          <h3 class="method-card-title">Evidenze prima delle opinioni</h3>
          <p class="method-card-text">
            Le decisioni relative a carichi, progressioni e test si fondano su riferimenti scientifici aggiornati e su criteri misurabili. L’obiettivo è ridurre l’improvvisazione e garantire coerenza nelle scelte tecniche aumentando i risultati agonistici.
          </p>
        </article>
        <article class="method-card">
          <h3 class="method-card-title">Tutela e sostenibilità</h3>
          <p class="method-card-text">
            La preparazione atletica è efficace solo se tutela la salute degli atleti ed è sostenibile nel tempo. Il metodo integra progressioni consapevoli e monitoraggio, per ridurre il rischio di sovraccarichi e infortuni.
          </p>
        </article>
        <article class="method-card">
          <h3 class="method-card-title">Adattabilità al contesto reale</h3>
          <p class="method-card-text">
            Ogni società sportiva presenta risorse, competenze e vincoli differenti. Il metodo viene calibrato sul contesto specifico, evitando modelli standardizzati irrealistici.
          </p>
        </article>
        <article class="method-card">
          <h3 class="method-card-title">Struttura organizzabile e replicabile</h3>
          <p class="method-card-text">
            Un buon sistema deve poter essere compreso, condiviso e applicato. Lavoriamo a stretto contatto con lo staff per creare un know-how comune che migliori l’organizzazione della preparazione atletica all’interno della società
          </p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MethodSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.method-section {
  position: relative;
  color: $white;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.35);
    z-index: 1;
  }
}

.section-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.method-inner {
  position: relative;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  z-index: 2;
  gap: 32px;
}

.method-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.method-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

.method-subtitle,
.method-detail {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.7;
}

.method-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.method-card {
  background-color: $primary;
  border-radius: 25px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: $white;
  height: 304px;
}

.method-card-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: left;
}

.method-card-text {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.6;
  flex: 1;
  display: flex;
  align-items: center;
  text-align: left;
}

@media (min-width: 768px) {
  .method-inner {
    padding: 64px 40px;
  }

  .method-card {
    padding: 2rem;
    height: 232px;
  }
}

@media (min-width: 900px) and (orientation: landscape) {
  .method-inner {
    padding: 80px 120px;
    gap: 40px;
  }

  .method-title {
    font-size: 2.4rem;
  }

  .method-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
  }

  .method-card {
    padding: 2rem;
    height: 256px;
  }
}
</style>
